module.exports = __webpack_public_path__ + "img/GP 1 WE.Circular Bulgaria EWA.e468c099.png";